export default [
	{
		path: '/faq',
		name: 'FAQ',
		component: () => import('@/components/FAQ/index.vue'),
	},
	{
		path: '/faq/detail',
		name: 'FAQDetail',
		component: () => import('@/components/FAQ/detail.vue'),
	},
	{
		path: '/feedback',
		name: 'FeedBack',
		component: () => import('@/components/FeedBack/index.vue'),
	},
	{
		path: '/bind-phone-page',
		name: 'BindPhonePage',
		component: () => import('@/components/BindPhonePage.vue'),
	},
	{
		path: '/official-site-result',
		name: 'OfficialSiteResult',
		component: () => import('@/components/membership-system/OfficialSiteResult.vue'),
	},
];



// WEBPACK FOOTER //
// ./src/router/modules/common.js